import { Component, OnInit, Input, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
import { faCircle, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faGrinStars } from '@fortawesome/free-regular-svg-icons';
import { SearchService } from 'src/app/services/search/search.service';
import { TranslateService } from '@xref/ngx';
import { SearchMenuService } from 'src/app/services/search-menu/search-menu.service';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';

@Component({
    selector: 'xqnr-suggestion-carousel',
    templateUrl: './suggestion-carousel.component.pug',
    styleUrls: ['./suggestion-carousel.component.scss'],
    standalone: false
})
export class SuggestionCarouselComponent implements OnInit {

  @Input() items: string[];
  @Input() items$: any;

  @Output() searchAction = new EventEmitter();

  slideWidth = 0;
  slideOffset = 0;
  activeSlide = 0;

  fa: any = {
    circle: faCircle,
    chevronRight: faChevronRight,
    chevronLeft: faChevronLeft,
    grinStars: faGrinStars
  };

  constructor(
    private el: ElementRef,
    private search: SearchService,
    private translate: TranslateService,
    private searchMenu: SearchMenuService,
    private suggestions: SuggestionService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    this.setSlideWidth();

    // Effectively re-calculates slide offset when window resizes
    setTimeout(() => this.changeSlide(this.activeSlide), 100);
  }

  ngOnInit(): void {
    this.setSlideWidth();

    this.items$.subscribe(() => {
      this.changeSlide(0);
    });
  }

  setSlideWidth() {
    this.slideWidth = this.el.nativeElement.querySelector('.carousel-wrapper').clientWidth;
  }

  getSlideLeftPos(index: number): number {
    return this.slideWidth * index;
  }

  getTotalSlideWidth() {
    return (this.items.length > 0 ? this.slideWidth * this.items.length : this.slideWidth);
  }

  changeSlide(index: number) {
    this.activeSlide = index;
    this.slideOffset = - (this.slideWidth * this.activeSlide);
  }

  searchFromSuggestionClicked(suggestionKey: string) {
    if (suggestionKey === 'minQuestions') {
      this.searchMenu.show();
      this.suggestions.hide();

    } else {
      this.translate.get(`suggestions.searchPrefill.${suggestionKey}`).subscribe((res: string) => {
        this.search.searchFor(res);
        this.searchAction.emit();
      });
    }
  }
}
